export const RoutesPath = {
  homePage: '/',
  sparePartOrders: '/spare-part-orders',
  interventionPage: '/intervention',
  catalogPage: '/catalog/v2',
  planningPage: '/planning',
  planningInterventionPage: '/planning/interventions',
  shippingPage: '/shipping',
  massiveInvoicePage: '/search/massive-invoice',
  customerPage: '/customer',
  customerCreatePage: '/customer/create',
  customerUpdatePage: '/customer/update',
  errorPage: '/errorPage',
  productPage: '/product',
  productInterventionPage: '/product/intervention',
  shippingGroupPage: '/shipping-group',
  adminPage: '/admin',
  searchPage: '/search',
  searchResultPage: '/search/results',
  forecastPage: '/forecast',
  delayParamPage: '/delays-parameters',
  bookingsPage: '/bookings',
  catalogProcessesPage: '/catalog/v2/processes',
  newCatalogSportsPage: '/catalog/v2/sports',
  usefulLinksPage: '/useful-links',
  accessibilityPage: '/accessibility',
  productSheetPage: '/product-sheet',
  interventionsListPage: '/interventions',
  interventionsCustomerPage: '/interventions-customer/:memberId',
  interventionsPartnersListPage: '/interventions-partners',
  interventionsCompleted: '/interventions-completed',
} as const;

export const getAppRoute = (route: (typeof RoutesPath)[keyof typeof RoutesPath], routeParam?: string) => {
  const param = routeParam ? `/${routeParam}` : '';
  return `${route}${param}`;
};
